<template>
  <div class="flex">
    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-tl-md rounded-bl-md mr-1',
        'cursor-pointer flex items-center justify-center select-none',
        undoDisabled ? 'won-color-disabled cursor-default' : 'won-color-subtitle-gray',
      ]"
      @click="handleUndo"
    >
      <undo />
    </div>
    <div
      :class="[
        'w-6 h-6 won-tag-light-gray rounded-tr-md rounded-br-md',
        'cursor-pointer flex items-center justify-center select-none',
        redoDisabled ? 'won-color-disabled cursor-default' : 'won-color-subtitle-gray',
      ]"
      @click="handleRedo"
    >
      <redo />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import Redo from '../../icons/redo.vue'
import Undo from '../../icons/undo.vue'

import { useBuilder } from '../../store/builder.store'

const builder = useBuilder()
const { history, historyIndex } = storeToRefs(builder)

const handleUndo = () => {
  builder.undo()
}

const handleRedo = () => {
  builder.redo()
}

const undoDisabled = computed(() => {
  return historyIndex.value <= 0
})

const redoDisabled = computed(() => {
  return historyIndex.value === history.value.length - 1
})
</script>

<style></style>
